import Axios from "axios";

export class ClientePnService {

    getLista(params) {
        const queryParams = params ? Object.keys(params).map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k])).join('&') : '';
        return Axios.get(`${process.env.REACT_APP_URL_BACK}/ficha/trust/cliente-pn/lista?${queryParams}`).then(res => res.data);
    }

    newCliente(data) {
        return Axios.post(`${process.env.REACT_APP_URL_BACK}/ficha/trust/cliente-pn/nuevo`, data).then(res => res.data);
    }

    editarCliente(data) {
        return Axios.put(`${process.env.REACT_APP_URL_BACK}/ficha/trust/cliente-pn/editar`, data).then(res => res.data);
    }

    eliminarCliente(id) {
        return Axios.delete(`${process.env.REACT_APP_URL_BACK}/ficha/trust/cliente-pn/eliminar/${id}`).then(res => res.data);
    }

    consultarCliente(id, opciones = {}) {
        return Axios.get(`${process.env.REACT_APP_URL_BACK}/ficha/trust/cliente-pn/consulta/${id}`, { params: opciones }).then(res => res.data);
    }

    descargar(id, opciones = {}) {
        return Axios.get(`${process.env.REACT_APP_URL_BACK}/ficha/trust/cliente-pn/reporte/${id}`,
            { params: opciones, headers: { 'Content-Type': 'application/json', 'Pragma': 'no-cache' }, responseType: 'blob' }).then(async res => res.data);
    }

    getArbolAnexos(id, opciones = {}) {
        return Axios.get(`${process.env.REACT_APP_URL_BACK}/ficha/trust/cliente-pn/arbol-anexos/${id}`, { params: opciones }).then(res => res.data);
    }
}
